import { Action } from 'redux';

import { WhoHasSeenThisView } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export interface WhoHasSeenThisViewAction extends Action {
  view: IContentInfo;
}

export function whoHasSeenThisView(view: IContentInfo) {
  return {
    type: WhoHasSeenThisView,
    view
  };
}

export const isWhoHasSeenThisViewAction = isActionFactory<WhoHasSeenThisViewAction>(WhoHasSeenThisView);
